import React, { useEffect } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import useGetJobInterviews from '../../../../hooks/dashboard/jobs/useGetJobInterviews';
import useGetAcceptedJobApplicants from '../../../../hooks/dashboard/jobs/useGetAcceptedJobApplicants';
import InterviewCard from './InterviewCard';
import AcceptedCard from '../AcceptedCard/AcceptedCard';
import { useApplicantsRefresh } from '../../../../context/ApplicantRefreshContext';

interface InterviewProps {
  jobId: string;
}
const Interview: React.FC<InterviewProps> = ({ jobId }) => {
  const { refresh } = useApplicantsRefresh();

  const { getJobInterviews, loading, interviews } = useGetJobInterviews();

  const { getAcceptedJobApplicants, applicantData } =
    useGetAcceptedJobApplicants();

  // Load the applicants on mount
  useEffect(() => {
    getJobInterviews(jobId);
    getAcceptedJobApplicants(jobId);
  }, [jobId, getJobInterviews, getAcceptedJobApplicants, refresh]);

  if (!loading && !interviews?.length && !applicantData?.length) {
    return <Container>No available interview</Container>;
  }

  return (
    <Container>
      {applicantData &&
        applicantData?.map((data: any, index: any) => (
          <AcceptedCard key={index} {...data} setStatus="ACCEPTED" />
        ))}
      {loading ? (
        <LoadingOutlined />
      ) : (
        interviews?.map((data, index) => (
          <InterviewCard
            key={index}
            {...data}
            setStatus="ACCEPTED"
            nullify={applicantData?.length > 0}
          />
        ))
      )}
    </Container>
  );
};

export default Interview;

const Container = styled.div`
  /* border: 1px solid blue; */
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
  }
`;
